import React from 'react';
import { FileTextIcon, MessageSquareIcon, BookmarkIcon, DownloadIcon } from 'lucide-react';
interface AlgaCoffeeNotesWidgetProps {
  coffeeHost: string;
}
const AlgaCoffeeNotesWidget: React.FC<AlgaCoffeeNotesWidgetProps> = ({
  coffeeHost
}) => {
  return <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm" data-id="element-392">
      <div className="p-4 border-b border-gray-200 flex items-center" data-id="element-393">
        <div className="w-8 h-8 rounded-full overflow-hidden border-2 border-pink-500 mr-3" data-id="element-394">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/x28iigDaSByhSaf2N4iVm6/IMG_0007.png" alt="ALGA AI Assistant" className="w-full h-full object-cover" data-id="element-395" />
        </div>
        <div data-id="element-396">
          <h2 className="text-base font-semibold text-gray-800" data-id="element-397">
            Appunti intelligenti
          </h2>
          <p className="text-xs text-gray-500" data-id="element-398">Powered by EIIS Intelligence</p>
        </div>
      </div>
      <div className="p-4" data-id="element-399">
        <div className="space-y-4" data-id="element-400">
          <div className="flex items-center justify-between" data-id="element-401">
            <h4 className="text-sm font-medium text-gray-800" data-id="element-402">
              Appunti e note
            </h4>
            <div className="flex items-center space-x-2" data-id="element-403">
              <button className="p-1 rounded-full hover:bg-gray-100" data-id="element-404">
                <BookmarkIcon size={16} className="text-gray-500" data-id="element-405" />
              </button>
              <button className="p-1 rounded-full hover:bg-gray-100" data-id="element-406">
                <DownloadIcon size={16} className="text-gray-500" data-id="element-407" />
              </button>
            </div>
          </div>
          <div className="bg-custom-green/5 p-2 rounded-lg border border-custom-green/20 text-xs text-gray-600 flex items-center" data-id="element-408">
            <div className="w-5 h-5 rounded-full overflow-hidden border border-pink-500 mr-2 flex-shrink-0" data-id="element-409">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/x28iigDaSByhSaf2N4iVm6/IMG_0007.png" alt="ALGA AI" className="w-full h-full object-cover" data-id="element-410" />
            </div>
            <span data-id="element-411">
              Ho analizzato autonomamente l'evento e preparato questi appunti
              per te
            </span>
          </div>
          <div className="bg-gray-50 p-3 rounded-lg border border-gray-200" data-id="element-412">
            <div className="flex items-start mb-2" data-id="element-413">
              <FileTextIcon size={16} className="text-custom-green mt-1 mr-2 flex-shrink-0" data-id="element-414" />
              <div data-id="element-415">
                <h5 className="text-sm font-medium text-gray-800" data-id="element-416">
                  Concetti chiave
                </h5>
                <ul className="list-disc pl-5 text-sm text-gray-600 mt-1 space-y-1" data-id="element-417">
                  <li data-id="element-418">Integrazione ESG nel core business</li>
                  <li data-id="element-419">Misurazione dell'impatto attraverso KPI specifici</li>
                  <li data-id="element-420">Coinvolgimento degli stakeholder</li>
                  <li data-id="element-421">Reporting trasparente e verificabile</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 p-3 rounded-lg border border-gray-200" data-id="element-422">
            <div className="flex items-start mb-2" data-id="element-423">
              <MessageSquareIcon size={16} className="text-custom-green mt-1 mr-2 flex-shrink-0" data-id="element-424" />
              <div data-id="element-425">
                <h5 className="text-sm font-medium text-gray-800" data-id="element-426">
                  Citazioni importanti
                </h5>
                <p className="text-sm text-gray-600 mt-1 italic" data-id="element-427">
                  "La sostenibilità non è più un'opzione, ma una necessità
                  strategica per rimanere competitivi nel mercato attuale."
                </p>
                <p className="text-sm text-gray-500 mt-1" data-id="element-428">- {coffeeHost}</p>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 p-3 rounded-lg border border-gray-200" data-id="element-429">
            <div className="flex items-start mb-2" data-id="element-430">
              <FileTextIcon size={16} className="text-custom-green mt-1 mr-2 flex-shrink-0" data-id="element-431" />
              <div data-id="element-432">
                <h5 className="text-sm font-medium text-gray-800" data-id="element-433">
                  Risorse consigliate
                </h5>
                <ul className="list-disc pl-5 text-sm text-gray-600 mt-1 space-y-1" data-id="element-434">
                  <li data-id="element-435">
                    Report "ESG Integration in Business Strategy" (EIIS, 2023)
                  </li>
                  <li data-id="element-436">Framework GRI per il reporting di sostenibilità</li>
                  <li data-id="element-437">Casi studio di aziende leader nel settore</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="mt-3 flex justify-center" data-id="element-438">
            <button className="text-xs text-custom-green hover:text-custom-green/80 flex items-center" data-id="element-439">
              <FileTextIcon size={12} className="mr-1" data-id="element-440" />
              Richiedi appunti specifici
            </button>
          </div>
        </div>
      </div>
    </div>;
};
export default AlgaCoffeeNotesWidget;